<template>
    <div class="sub-header">
        <nav class="navbar navbar-expand">
            <div class="collapse navbar-collapse d-flex pb-4 justify-content-between">

                <v-row class="w-100">
                        <v-col cols="12" md="12" class="search-wrapper" lg="4">
                            <form v-if="searchShow" @submit.prevent="handleSearch" class="form-inline d-flex pr-0" method="get">

                                <input
                                    v-model="searchTerm"
                                    name="search"
                                    type="text"
                                    class="form-control bg-grey-lighten-3 custom-search"
                                    :placeholder="$t('search')"
                                    style="font-size: 18px;"
                                />
                                <i class="fa fa-search search-icon" @click="handleSearch"></i>
                                </form>
                        </v-col>
                        <v-col cols="12" lg="8" sm="12" class="menu-responsive">
                            <ul class="navbar-nav d-flex jusitify-content-center overflow-x-auto">
                                <v-spacer class="spacer-menu"></v-spacer>
                                <li class="px-0 nav-item d-flex align-items-center">
                                    <Link :class="{'select-highlight': '' === currentSlug}" style="font-size: 20px;"  class="nav-link font-size-responsive" :href="route('home.index')">
                                        {{ $t('submenu.home') }}
                                    </Link>
                                </li>


                                <li class="px-0 nav-item d-flex align-items-center" v-for="(menu, index) in menuCategories"
                                    :key="index">
                                    <Link :class="{'select-highlight': menu.parameters?.slug === currentSlug}" style="font-size: 20px;"  class="nav-link font-size-responsive" :href="route(menu.route, menu.parameters?.slug)">
                                        {{ $t('submenu.'+menu.parameters?.slug) }}
                                    </Link>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>

            </div>
        </nav>
    </div>
</template>

<script setup>

import {computed, ref} from "vue";
const menuCategories = computed(() => usePage().props.menu_item);
const emit = defineEmits(['onSearch']);
const searchTerm = ref('');

const props = defineProps({
    searchShow: Boolean,
    search: String,
});


function handleSearch() {
    emit('onSearch', searchTerm.value);
}

const currentSlug = computed(() => {
    const url = window.location.href;
    const urlSplit = url.split('/');
    return urlSplit[urlSplit.length - 1] ?? '';
});

import {Link, usePage} from "@inertiajs/vue3";

</script>

<style scoped>
@media (max-width: 768px) {
    .font-size-responsive {
        font-size: 18px !important;
    }
    .menu-responsive {
        width: 300px;                  /* Ensure the menu takes up full width of its parent container */
        max-width: 100%;              /* Prevent exceeding the parent container's width */
        -webkit-overflow-scrolling: touch;  /* Smooth scrolling on iOS devices */
        padding-top: 0px;
        padding-bottom: 0px;
        overflow-x: auto;             /* Enable horizontal scrolling */
        white-space: nowrap;          /* Prevent menu items from wrapping to the next line */
        display: flex;                /* Align items horizontally in a row */
        flex-shrink: 0;               /* Prevent menu items from shrinking */
        overflow: hidden;           /* Prevent vertical scrolling */
        margin-bottom: 20px;
    }
    
    .spacer-menu {
        display: none;
    }
}

.custom-search {
    border-radius: 50px;
    background-color: #F0F0F080;
    border: none;
    padding-left: 20px;
    padding-right: 20px;
    height: 45px;
}
.fa-search:before {
    margin-right: 10px;
}
.custom-search:focus {
    box-shadow: none;
    outline: none;
}

.search-wrapper {
    position: relative;
    max-width: 100%;
    flex: 1;
}

.search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
}




</style>
